type ScrapProps = {
  color?: string
}

function Scrap({ color = '#777' }: ScrapProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-label="스크랩"
    >
      <desc>스크랩</desc>
      <defs>
        <clipPath id="5utw0hroka">
          <path
            fill="none"
            stroke={color}
            d="M0 0h20v20H0z"
            data-name="사각형 3304"
            transform="translate(1392.5 570.5)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath="url(#5utw0hroka)"
        data-name="마스크 그룹 99"
        transform="translate(-1392.5 -570.5)"
      >
        <path
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M1407.11 586.427l-4.61-3.293-4.61 3.293V575.89a1.317 1.317 0 011.317-1.317h6.583a1.317 1.317 0 011.32 1.317z"
          data-name="bookmark (1)"
        ></path>
      </g>
    </svg>
  )
}

export default Scrap
